import React from "react";
import { LOCALE_STRINGS } from "constants/locales";
import { ReactComponent as ProcurementIcon } from "assets/icons/tradeRelationShips.svg";
import { ReactComponent as CounterpartyIcon } from "assets/icons/tradeSingle.svg";
import { ReactComponent as AutomationIcon } from "assets/icons/tradeAutomationHandles.svg";

export const FeatureGridSection = ({ language = "EN" }) => {

  return (
    <section className="feature-section">
      <div className="feature-content-block">
        <div className="feature-grid">
          <div className="feature-grid__col feature-grid__col--left">
            <div className="feature-card feature-card--tall">
              <div className="feature-card__icon-box">
                <CounterpartyIcon />
              </div>
              <h3 className="feature-card__title">
                {LOCALE_STRINGS[language]?.feature_counterparty_title}
              </h3>
              <p className="feature-card__text">
                {LOCALE_STRINGS[language]?.feature_counterparty_desc}
              </p>
            </div>
          </div>

          <div className="feature-grid__col">
            <div className="feature-card">
              <div className="feature-card__icon-box">
                <ProcurementIcon />
              </div>
              <h3 className="feature-card__title">
                {LOCALE_STRINGS[language]?.feature_procurement_title}
              </h3>
              <p className="feature-card__text">
                {LOCALE_STRINGS[language]?.feature_procurement_desc}
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-card__icon-box">
                <AutomationIcon />
              </div>
              <h3 className="feature-card__title">
                {LOCALE_STRINGS[language]?.feature_automation_title}
              </h3>
              <p className="feature-card__text">
                {LOCALE_STRINGS[language]?.feature_automation_desc}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
